const RepeatIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 19 19" fill="none" {...props}>
        {props.title ? <title>{props.title}</title> : ''}
        <path fill="currentColor" d="M10 1.25A8.75 8.75 0 1 0 18.75 10 8.76 8.76 0 0 0 10 1.25Zm0 16A7.25 7.25 0 1 1 17.25 10 7.26 7.26 0 0 1 10 17.25Z" />
        <path fill="currentColor" d="M6.5 7a.5.5 0 0 1 0-1h4.793L9.646 4.354a.5.5 0 0 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L11.293 7H6.5z" />
        <path fill="currentColor" d="M13.5 13a.5.5 0 0 1 0 1H8.707l1.647 1.646a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708.708L8.707 13H13.5z" />
    </svg>
)
export default RepeatIcon
